import getConfig from "next/config";

import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { RequestRecommendInterface } from "./recommendServiceInterface/getRecommendInterface";
import { ResponseRecommendInterface } from "./recommendServiceInterface/getRecommendInterface";

const config =
  typeof window === "undefined"
    ? getConfig()?.serverRuntimeConfig
    : getConfig()?.publicRuntimeConfig;
const cachesPromotionTime =
  config?.publicRuntimeConfig?.cachesPromotionTime || 1800;

class RecommendServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "hotel";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getRecommendList(
    params: RequestRecommendInterface,
  ): Promise<ResponseRecommendInterface> {
    const queryParams = new URLSearchParams(params as any);
    const revalidate = cachesPromotionTime;

    const response = (await apiRequest(
      this.baseUrl,
      `v5/${this.basePath}/Recommend?${queryParams}`,
      "GET",
      {},
      false,
      undefined,
      false,
      revalidate,
      false,
    )) as any;

    try {
      return new ResponseRecommendInterface(response);
    } catch (error) {
      return new ResponseRecommendInterface({});
    }
  }
}
export default RecommendServiceApi;
